import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToId } from "./Motion";

const LINKS = [
  { label: "Palestrantes", hash: "#autoridades" },
  { label: "Diferenciais", hash: "#diferenciais" },
  { label: "Local", hash: "#local" },
  { label: "Prêmio", hash: "#premio" },
  { label: "Inscrições", hash: "#ingressos" },
];

export default function SiteMenu() {
  const [open, setOpen] = useState(false);

  const go = (hash) => {
    setOpen(false);
    setTimeout(() => scrollToId(hash), 80);
  };

  return (
    <div className="fixed top-4 right-4 sm:top-5 sm:right-6 z-[70]" data-testid="site-menu">
      {/* Botão fixo glass */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Fechar menu" : "Abrir menu"}
        aria-expanded={open}
        className="flex items-center gap-2.5 rounded-full glass-strong pl-4 pr-2.5 py-2.5 transition-all duration-300 hover:border-white/35 hover:bg-white/[0.08]"
        data-testid="site-menu-button"
      >
        <span className="font-display font-bold uppercase tracking-[0.14em] text-white text-[11px]">
          Menu
        </span>
        <span className="h-8 w-8 rounded-full bg-white/[0.08] border border-white/15 flex items-center justify-center text-white">
          {open ? <X size={15} /> : <Menu size={15} />}
        </span>
      </button>

      {/* Painel de navegação */}
      <AnimatePresence>
        {open && (
          <>
            <button
              aria-hidden="true"
              tabIndex={-1}
              onClick={() => setOpen(false)}
              className="fixed inset-0 -z-10 cursor-default"
              data-testid="site-menu-backdrop"
            />
            <motion.nav
              initial={{ opacity: 0, y: -10, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -10, scale: 0.97 }}
              transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
              className="absolute right-0 top-full mt-3 w-64 rounded-2xl glass-strong p-2 origin-top-right"
              data-testid="site-menu-panel"
            >
              {LINKS.map((l, i) => (
                <button
                  key={l.hash}
                  onClick={() => go(l.hash)}
                  className="group w-full flex items-center justify-between gap-3 rounded-xl px-4 py-3.5 text-left transition-colors duration-200 hover:bg-white/[0.07]"
                  data-testid={`site-menu-link-${l.hash.slice(1)}`}
                >
                  <span className="flex items-baseline gap-3">
                    <span className="font-mono text-[10px] text-white/35 tabular-nums">
                      0{i + 1}
                    </span>
                    <span className="font-display font-bold uppercase tracking-[0.06em] text-white/85 text-sm group-hover:text-white">
                      {l.label}
                    </span>
                  </span>
                  <ArrowUpRight
                    size={14}
                    className="text-white/25 transition-all duration-200 group-hover:text-white/80 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </button>
              ))}
            </motion.nav>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
